<template>
	<router-view />
</template>
<script>
	export default {
		name: 'BaseAplication',
	};
</script>



// WEBPACK FOOTER //
// src/base.vue